// extracted by mini-css-extract-plugin
export default {"filters":"PopularSports_filters__j9diS","head2headContainer":"PopularSports_head2headContainer__dSso0","noEvents":"PopularSports_noEvents__diimA","card":"PopularSports_card__vFhcD"};